import React, { useState, useEffect } from "react";
import BaseModal from "../BaseModal";
import Button from "../../Buttons/Button";
import CheckBox from "../../Checkbox";
import "./style.css";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

export const AnalyticsFilter = ({
  onClose,
  options,
  applyFilter,
  selectedOptions,
  setSelectedOptions,
  filterDates,
  setFilterDates,
  dateofDiagnosis,
}) => {
  const [isFiltered, setIsFiltered] = useState(false);

  const handleCheckboxChange = (category, value) => {
    setSelectedOptions((prevSelectedOptions) => {
      // If the category already exists in the selected options
      if (prevSelectedOptions.hasOwnProperty(category)) {
        // Check if the value is already in the array
        if (prevSelectedOptions[category].includes(value)) {
          // If yes, remove it
          return {
            ...prevSelectedOptions,
            [category]: prevSelectedOptions[category].filter(
              (item) => item !== value
            ),
          };
        } else {
          // If not, add it
          return {
            ...prevSelectedOptions,
            [category]: [...prevSelectedOptions[category], value],
          };
        }
      } else {
        // If the category doesn't exist, create a new array with the value
        return {
          ...prevSelectedOptions,
          [category]: [value],
        };
      }
    });
  };

  //   console.log(selectedOptions, "selected options");

  const handleCancel = () => {
    onClose();
  };

  const handleApplyFilter = async (event) => {
    try {
      // Replace with your actual API call to apply filter
      // await new Promise((resolve) => setTimeout(resolve, 1000));
      //   let filtersArray = [
      //     ...selectedOptions.cityFilters,
      //     ...selectedOptions.cancerTypeFilters,
      //     ...selectedOptions.geneNameFilters,
      //     ...selectedOptions.biomarkerFilters,
      //   ];

      //   applyFilter(filtersArray);
      applyFilter(selectedOptions);
      setIsFiltered(true);
    } catch (error) {
      console.error("Error applying filter:", error);
    }
  };

  const handleFlyerMessageClose = () => {
    onClose();
    setIsFiltered(false);
  };

  return (
    <BaseModal
      title="Investigations & Treatment Filter"
      onClose={onClose}
      showFlyerMessage={isFiltered}
      flyerMessageText={"Filter has been applied successfully"}
      onFlyerMessageClose={handleFlyerMessageClose}
    >
      <div className="filter-column">
        {options.city.length > 0 && (
          <div className="filter-column-text">City</div>
        )}
        {options.cancerType.length > 0 && (
          <div className="filter-column-text">Cancer Type</div>
        )}
        {options.geneName.length > 0 && (
          <div className="filter-column-text">Mutations</div>
        )}
        {options.biomarker.length > 0 && (
          <div className="filter-column-text">Biomarkers</div>
        )}
        {dateofDiagnosis && (
          <div className="filter-column-text">Date Of Diagnosis (From-To)</div>
        )}
      </div>

      <div className="filter-items">
        {Object.keys(options).map((category, index) => (
          <div className="filter-items-group" key={index}>
            {options[category].map((type, i) => (
              <CheckBox
                key={i}
                className="check-box-instance"
                label
                stateProp="default"
                text={type?.name}
                toggle={selectedOptions[category].includes(type?.name)}
                onChange={(value) => handleCheckboxChange(category, value)}
              />
            ))}
          </div>
        ))}
        {dateofDiagnosis && (
          <div className="filter-items-group" style={{ gap: "10px" }}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                className="filter-input"
                value={filterDates.startMonth}
                onChange={(value) => {
                  setFilterDates({
                    ...filterDates,
                    ["startMonth"]: value,
                  });
                }}
                label="From"
                sx={{ width: "12rem" }}
                views={["month", "year"]}
                slotProps={{ textField: { size: "small" } }}
                monthsPerRow={4}
              />
            </LocalizationProvider>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                className="filter-input"
                value={filterDates.endMonth}
                onChange={(value) => {
                  setFilterDates({
                    ...filterDates,
                    ["endMonth"]: value,
                  });
                }}
                label="To"
                sx={{ width: "12rem" }}
                views={["month", "year"]}
                slotProps={{ textField: { size: "small" } }}
                monthsPerRow={4}
              />
            </LocalizationProvider>
            <button
              id="clear-button"
              onClick={() => {
                setFilterDates({
                  startMonth: null,
                  endMonth: null,
                  startYear: null,
                  endYear: null,
                });
              }}
            >
              Clear
            </button>
          </div>
        )}
      </div>

      <div className="filter-btn-group ">
        <Button btnType="apply" onClick={handleApplyFilter} />
        <Button btnType="cancelWithIconAtFront" onClick={handleCancel} />
      </div>
    </BaseModal>
  );
};

export default AnalyticsFilter;
